export interface DictionarySapSymbolEntity {
    id: number;
    symbol: string;
    indexName: string;
    indexType: string;
}
